<template lang="pug">
  .about(v-if="content")
      .about__left
          .about__left-slider
              .swiper-container
                  .swiper-wrapper
                      .swiper-slide(v-for='(item, index) in content.slider' :key="index")
                          .about__left-slider-item-wr
                              img.about__left-slider-item-img(:src="item.path" :alt="item.title" :class="{'about__left-slider-item-img--hide': imgHide}")
                  .swiper-pagination
          .about__left-advantages
              .about__left-advantages-item(v-for='(item, index) in content.advantages' :key="index")
                  .about__left-advantages-item-img-wr
                    img.about__left-advantages-item-img(:src="item.icon.path" :alt='item.icon.title' :class="{'about__left-advantages-item-img--hide': imgHide}")
                  .about__left-advantages-item-text {{ item.text }}
      .about__right
          .about__right-wr
              h2.about__right-headline {{ content.headline }}
              .about__right-text(v-html="content.text")
</template>

<script>
// @ is an alias to /src
import '@/components/about/about.styl';
import EventBus from '@/eventBus';

import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {SliderHelpersVue} from "@/mixins/SliderHelpersVue";
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

export default {
    name: 'About',
    mixins: [AjaxHelpersVue, SliderHelpersVue],
    data() {
        return {
            content: null,
            objImages: [],
            imgHide: true,
        }
    },
    components: {
        SvgIcon
    },
    created() {
        EventBus.$on('loadAboutPage', params => {
            this.request(params.url, params);
        });

        EventBus.$on('imgLoaded', (res) => {
            this.imgHide = res;
        });
    },
    methods: {
        request(url, params) {
            this.req('AboutPage:getAboutPage', {url}, res => {
                $('.samedia').removeClass('samedia--hide');
                $('.footer').removeClass('footer--hide');
                EventBus.$emit('setMenuTopActiveClass', params.url, params.from);
                EventBus.$emit('pagePreloaderHide');
                if(this.checkProperty(res.content)) {
                    this.content = res.content;
                    for(let i = 0; i < this.content.slider.length; i++) {
                        this.objImages = this.objImages.concat({loaded: false, url: this.content.slider[i].path});
                    }
                    for(let i = 0; i < this.content.advantages.length; i++) {
                        this.objImages = this.objImages.concat({loaded: false, url: this.content.advantages[i].icon.path});
                    }
                    this.$nextTick(() => {
                        $('.samedia').removeClass('samedia--hide');
                        $('.footer').removeClass('footer--hide');
                        $('.page__decore--12').removeClass('page__decore--hide-bottom');
                        $('.page__decore--11').removeClass('page__decore--hide-bottom');
                        $('.page__decore--10').removeClass('page__decore--hide-bottom');
                        let swiper = this.initSlider('.about__left-slider');
                        EventBus.$emit('swiperInit', swiper);
                        this.checkImgLoading(this.objImages);
                        if($(window).width() > 1200) {
                            this.scrollInit();
                        }
                    });
                }
            }, 'about');
        },

        scrollInit() {
            $('.about__right').mCustomScrollbar({
                mouseWheel: {
                    enable: true
                },
                theme: "rounded-dark",
                scrollEasing: "linear",
            });
        }
    }
}
</script>
